<template>
  <div class="action-buttons">
    <button v-if="isAvailable(['admin', 'welder'])" class="btn btn-outline-success" @click="handleAction('viewRow')">
      <i class="fa fa-eye"></i>
    </button>
    <button v-if="data.disabled" class="btn btn-outline-primary" @click="handleAction('editRow')">
      <i class="fa fa-edit"></i>
    </button>
    <button v-if="!data.disabled" class="btn btn-outline-primary" @click="handleAction('saveRow')">
      <i class="fa fa-save"></i>
    </button>
    <button v-if="isAvailable(['admin'])" class="btn btn-outline-dark" @click="handleAction('deleteRow')">
      <i class="fa fa-trash"></i>
    </button>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ActionButtons",

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['meRoles'])
  },

  methods: {
    ...mapActions([
      'moderateRow',
    ]),

    handleAction(actionName) {

      if (actionName === 'saveRow' && this.isAvailable(['moderator'])) {
        if (this.data.tow !== 1 && this.data.status !== 0) {
          this.moderateRow({
            order_id: this.data.Id,
          });
        }
      }

      this.$store.commit(actionName, this.data)
    },
    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    }
  },
};
</script>

<style scoped>
.action-buttons {
  display: flex;
  align-items: center;
}

.action-buttons button {
  margin: 0 3px;
}

.action-buttons button i {
  font-size: 14px;
}
</style>
